import { RuntimeEnvironmentOptions, getEnvFromHostname } from '@growtherapy/analytics';

import { getTelehealthConfig } from '../config';
import { LOGIN_CALLBACK_PATH, PROVIDER_LOGIN_PATH } from '../nav/config';
import { UserType } from '../types';
import { Auth0Config } from './types';
import { getAndSetUserTypeMemoized } from './userType';

const SCOPE = 'openid email profile offline_access';

function getRedirectUri(): Auth0Config['redirectUri'] {
  return `${location.origin}${LOGIN_CALLBACK_PATH}`;
}

function getAuthorizeTimeoutInSeconds(): Auth0Config['authorizeTimeoutInSeconds'] {
  return getTelehealthConfig().auth0_config?.authorizeTimeoutInSeconds;
}

function getHttpTimeoutInSeconds(): Auth0Config['httpTimeoutInSeconds'] {
  return getTelehealthConfig().auth0_config?.httpTimeoutInSeconds;
}

export function getAuth0Config(isCustomDomainEnabled = false): Auth0Config {
  const env = getEnvFromHostname({ hostname: window.location.hostname });
  const userType = getAndSetUserTypeMemoized(window.location.pathname);

  switch (env) {
    case RuntimeEnvironmentOptions.production: {
      const MONOLITH_AUDIENCE = 'https://growtherapy.us.auth0.com/api/v2/';
      const TELEHEALTH_AUDIENCE = 'https://telehealth.growtherapy.com/api';

      return {
        domain: isCustomDomainEnabled ? 'login.growtherapy.com' : 'growtherapy.us.auth0.com',
        clientId: 'guGGikPlebDR5Qa1yJ578syyaCYlIOmj',
        audience: userType === UserType.CLIENT ? MONOLITH_AUDIENCE : TELEHEALTH_AUDIENCE,
        scope: SCOPE,
        loginUri: `${location.origin}${PROVIDER_LOGIN_PATH}`,
        redirectUri: getRedirectUri(),
        authorizeTimeoutInSeconds: getAuthorizeTimeoutInSeconds(),
        httpTimeoutInSeconds: getHttpTimeoutInSeconds(),
      };
    }
    case RuntimeEnvironmentOptions.development: {
      const MONOLITH_AUDIENCE = `https://${import.meta.env.VITE_DEVELOPMENT_AUTH0_DOMAIN as string}/api/v2/`;
      const TELEHEALTH_AUDIENCE = import.meta.env.VITE_DEVELOPMENT_AUTH0_AUDIENCE as string;

      return {
        domain: import.meta.env.VITE_DEVELOPMENT_AUTH0_DOMAIN as string,
        clientId: import.meta.env.VITE_DEVELOPMENT_AUTH0_CLIENT_ID as string,
        audience: userType === UserType.CLIENT ? MONOLITH_AUDIENCE : TELEHEALTH_AUDIENCE,
        scope: SCOPE,
        loginUri: `${location.origin}${PROVIDER_LOGIN_PATH}`,
        redirectUri: getRedirectUri(),
        authorizeTimeoutInSeconds: getAuthorizeTimeoutInSeconds(),
        httpTimeoutInSeconds: getHttpTimeoutInSeconds(),
      };
    }
    default: {
      const MONOLITH_AUDIENCE = 'https://growtherapystaging.us.auth0.com/api/v2/';
      const TELEHEALTH_AUDIENCE = 'https://telehealth.growtherapystaging.com/api';

      return {
        domain: isCustomDomainEnabled ? 'login.growtherapystaging.com' : 'growtherapystaging.us.auth0.com',
        clientId: 'HUCGLL3eECkRLo0xhu5Dp7sOygBHmNvL',
        audience: userType === UserType.CLIENT ? MONOLITH_AUDIENCE : TELEHEALTH_AUDIENCE,
        scope: SCOPE,
        loginUri: `${location.origin}${PROVIDER_LOGIN_PATH}`,
        redirectUri: getRedirectUri(),
        authorizeTimeoutInSeconds: getAuthorizeTimeoutInSeconds(),
        httpTimeoutInSeconds: getHttpTimeoutInSeconds(),
      };
    }
  }
}
